import React from 'react';

const StatusBadge = ({ status }) => (
  <span
    className={
      status === "active"
        ? "badge-success"
        : status === "completed"
        ? "badge-neutral"
        : "badge-accent"
    }
  >
    {status === "active" ? "Active" : status === "completed" ? "Completed" : "Draft"}
  </span>
);

export default StatusBadge;
